import React, { useEffect, useState } from 'react';
import { Switch, TextBox } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';

import CopyIcon from "../../../../assets/common/copy.svg";
import DeleteIcon from "../../../../assets/common/delete.svg";
import ArrowDown from "../../../../assets/common/arrowDown.svg";
import TextFieldBox from '../components/text_field_box';
import OptionsList from './OptionsList';
import BranchingOptionsList from './BranchingOptionsList';
import { ShowDialog } from '../../../../components/reusableItems/dialog';

const Item = React.memo(({ question, index, updateQuestion, deleteQuestion, copyQuestion, types, enQuestions, zhQuestions, tab, showValidateError }) => {
    const [showDelete, setShowDelete] = useState(false);
    const [tempId, setTempId] = useState("");

    const actionTrigger = () => {
        deleteQuestion(tempId);
        setTempId('');
        setShowDelete(false);
    };

    return (
        <div>
            {showDelete && (
                <ShowDialog
                    title={"Please Confirm!"}
                    content={"Are you sure you want to delete?"}
                    cancelContent={"Cancel"}
                    confrimContent={"Delete"}
                    cancelbtn={() => setShowDelete(false)}
                    confrinbtn={actionTrigger}
                />
            )}

            <div className="poll_and_survey_create_item_main_box">
                <div className='flex-between'>
                    <div className="poll_and_survey_create_item_main_box_title">{`Question ${index + 1} ${question.expandable ? '' : `(${question.qtitle})`}`}</div>
                    <div
                        onClick={() => {
                            updateQuestion(question.qid, "expandable", !question.expandable);
                        }}
                    >
                        <img
                            src={ArrowDown}
                            className={`expandable-icon ${question.expandable ? "arrow expanded" : "arrow"}`}
                        />
                    </div>
                </div>

                {question.expandable && (<><div className="poll_and_survey_create_item_row">
                    <div className="poll_and_survey_main_box">
                        <div className="poll_and_survey_main_box_title">Title <span style={{ color: "red" }}>*</span></div>
                        <div>
                            <TextBox
                                className="poll_and_survey_main_box_field"
                                value={question.qtitle}
                                onChange={(e) => updateQuestion(question.qid, "qtitle", e.target.value)}
                            />
                            {(showValidateError && !question.qtitle) && (
                                <div className="poll_and_survey_error_text">{'Required Field'}</div>
                            )}
                        </div>
                    </div>
                    <div className="poll_and_survey_main_box">
                        <div className="poll_and_survey_main_box_title">Types <span style={{ color: "red" }}>*</span></div>
                        <div>
                            <DropDownList
                                data={types}
                                textField="name"
                                dataItemKey="value"
                                value={question.qtype}
                                onChange={(e) => {
                                    updateQuestion(question.qid, "qtype", e.target.value)
                                }}
                                placeholder="Select Type"
                                className="poll_and_survey_create_item_main_box_field tutorial_dropdown"
                                itemRender={itemRender}
                            />
                            {(showValidateError && question.qtype?.value == null ) && (
                                <div className="poll_and_survey_error_text">{'Required Field'}</div>
                            )}
                        </div>
                    </div>

                </div>
                    <div>

                        {question.qtype.value == "single-choice" || question.qtype.value == "multiple-choice" ? (
                            <OptionsList question={question} updateQuestion={updateQuestion} showValidateError={showValidateError} />
                        ) : null}

                        {question.qtype.value == "branching" ? (
                            <BranchingOptionsList question={question}
                                enQuestions={enQuestions}
                                zhQuestions={zhQuestions}
                                updateQuestion={updateQuestion}
                                tab={tab}
                                showValidateError={showValidateError}
                            />
                        ) : null}

                    </div>

                </>)}
                <div className="poll_and_survey_footer_action">

                    <div
                        className="poll_and_survey_footer_action_icon"
                        onClick={() => {
                            copyQuestion(question.qid);
                        }}
                    >
                        <img src={CopyIcon} />
                    </div>

                    <div
                        className="poll_and_survey_footer_action_icon"
                        onClick={() => {
                            setTempId(question.qid);
                            setShowDelete(true);
                        }}
                    >
                        <img src={DeleteIcon} />
                    </div>

                    <div style={{ borderLeft: "2px solid #CCCCCC", height: "40px" }}></div>
                    <div className="poll_and_survey_main_box_title">Required</div>

                    <div className="toggle-comment">
                        <Switch
                            defaultChecked={question.is_required}
                            offLabel=""
                            onLabel=""
                            size="small"
                            onChange={async (selected) => {

                                updateQuestion(question.qid, "is_required", selected?.value)
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
});

const itemRender = (li, itemProps) => {
    return React.cloneElement(li, {
        style: {
            height: "48px",
            lineHeight: "48px",
        },
    });
};

export default Item;
